<template>
  <keep-alive>
    <router-view />
  </keep-alive>
</template>

<script>
export default {
  name: "RegSite"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/contents/main/more/RegSite.vue